export default __webpack_public_path__ + "static/media/LifestyleCancellationPageMobileHeader2.93958ba1.jpg";